import { reportError } from './error-handling-service';

export default (restClient, args) => restClient({
  method: 'post',
  url: '/roadblock-notification',
  data: {
    ...args,
  },
  timeout: 10000,
  baseURL: process.env.REACT_APP_CAMPAIGN_OVERVIEW_API_URL,
}).catch(error => {
  reportError('SEND_NOTIFICATION_ERROR', error);
});



/** WEBPACK FOOTER **
 ** ./src/utils/send-limits-exceeded-notifcation.js
 **/